<template>
  <div id="app">
    <Header/>
    <router-view/>
    <!-- <Footer class="footer"/> -->
  </div>
</template>

<script>
import Header from './components/Header.vue'
// import Footer from './components/Footer.vue'
export default {
  name: 'App',
  components:{
    Header
  },
  data(){
    return {
      path: ''
    }
  },
  created(){
    this.pageInit()
  },
  methods:{
    pageInit: function() {
      // console.log(this.$route)
    }
  }
}
</script>

<style>
.footer {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue